import React from 'react';
import {
  FieldInputProps,
  FieldMetaProps,
} from '../../Constants/ReduxFormPropTypes';

const ZipField = ({ input, meta }) => (
  <div className="col-sm form-group">
    <label
      htmlFor={input.name}
      className={
        meta.touched && meta.error ? 'label form-error__label' : 'label'
      }
    >
      Venue zipcode
    </label>
    <div className="label__subtext">
      Please enter the venue zipcode as it appears on your policy. (Example:
      12345-6789)
    </div>
    {meta.touched && meta.error && (
      <div className="form-error">{meta.error}</div>
    )}
    <input
      {...input}
      id={input.name}
      className="form-control form-control-lg w-25 mb-4 cancelfield"
      aria-label="Zipcode"
      type="tel"
    />
  </div>
);
ZipField.propTypes = {
  input: FieldInputProps.isRequired,
  meta: FieldMetaProps.isRequired,
};

export default ZipField;
